<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title" style="width: 55px;">渠道号</span>
        <el-input v-model="parameter.channel_code" />
      </div>
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放组'"
          @select="handleSelect"
          @clear="(parameterNames.release_group_id_name = null),(parameter.release_group_id = null)"
        />
      </div>
      <div class="item">
        <span class="item_title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投手'"
          @select="handleSelect"
          @clear="(parameterNames.pitcher_id_name = null),(parameter.pitcher_id = null)"
        />
      </div>
      <div class="item">
        <span class="item_title">书籍归属</span>
        <el-autocomplete
          v-model="parameterNames.book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书籍归属'"
          @clear="(parameterNames.book_id_name = null),(parameter.book_id = null)"
          @select="handleSelect"
        />
      </div>
      <!-- <div class="item">
        <span class="item_title">书名</span>
        <el-autocomplete
          v-model="parameterNames.alias_book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书名'"
          @clear="(parameterNames.alias_book_id_name = null),(parameter.alias_book_id = null)"
          @select="handleSelect"
        />
      </div> -->
      <!-- <div class="item">
        <span class="item_title">投放位置</span>
        <el-autocomplete
          v-model="parameterNames.position_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放位置'"
          @clear="(parameterNames.position_id_name = null),(parameter.position_id = null)"
          @select="handleSelect"
        />
      </div> -->
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-circle-plus" @click="establish">创建</el-button>
      <!-- <el-button style="height:37px" type="primary" icon="el-icon-circle-plus" @click="download">表格</el-button> -->
      <el-button style="height:37px" type="primary" icon="el-icon-notebook-2" @click="dialogfiles=true">导入</el-button>

    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="id"
        />
        <el-table-column
          prop="channel_codes"
          label="渠道号"
          width="200"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="scope.row.channel_codes"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="ocean_advertiser_ids"
          label="巨量广告"
          width="300"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="scope.row.ocean_advertiser.map((item)=>{
                return `${item.account_name}（${item.account_id}）`
              })"
            />
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="adq_advertiser_ids"
          label="ADQ广告主"
          width="200"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="scope.row.adq_advertiser.map((item)=>{
                return `${item.account_name}（${item.account_id}）`
              })"
            />

          </template>
        </el-table-column> -->
        <el-table-column
          prop="platform_name"
          label="平台"
        />
        <el-table-column
          prop="release_group_name"
          label="投放组"
        />
        <el-table-column
          prop="pitcher_name"
          label="投手"
        />
        <!-- <el-table-column
          prop="novel_name"
          label="书名"
          width="120"
        /> -->
        <el-table-column
          prop="belong_name"
          label="书籍归属"
        />
        <!-- <el-table-column
          prop="position_name"
          label="投放位置"
        /> -->
        <el-table-column
          prop="begin_time"
          label="开始时间"
        />
        <!-- <el-table-column
          prop="end_time"
          label="结束时间"
        /> -->
        <el-table-column
          prop="created_at"
          label="创建时间"
        />
        <el-table-column
          prop="updated_at"
          label="修改时间"
        />
        <el-table-column
          label="操作"
          min-width="150"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="modify(scope.row)">修改</el-button>
            <el-button type="primary" size="mini" @click="myDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="drawerItem && drawerItem.id ? '修改关系' : '创建关系'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      style="min-width:680px"
      @closed="drawerItem = {}"
      @close="close"
    >
      <Details v-if="dialogVisible" ref="details" :drawer-item="drawerItem" @determine="determine" />
    </el-dialog>
    <el-dialog
      title="导入"
      :visible.sync="dialogfiles"
      :close-on-click-modal="false"
      width="40%"
      style="min-width:680px"
      @close="(filesxlsxname=''),(filesxlsx='')"
    >
      <div>
        <el-button slot="trigger" size="small" type="primary" style="float: right;">
          <a
            :href="tableData.download"
            style="color: white;"
          >下载模板</a>
        </el-button>
        <div style="display: flex;flex-direction: column;">
          <div>
            <el-button v-if="filesxlsxname===''" type="success" style="height: 35px;" icon="el-icon-upload" size="small" @click="$refs.fileinput.click()">上传文件
              <input ref="fileinput" style="display:none;" type="file" accept=".xlsx" @change="uploadXlsx($event)">
            </el-button>
            <div v-if="filesxlsxname">
              <span>
                {{ filesxlsxname }}
              </span>
              <i
                :class="['el-icon-upload-success', hoverClass]"
                @mouseenter="hoverClass = 'el-icon-circle-close'"
                @mouseleave="hoverClass = 'el-icon-circle-check'"
                @click="handleClick"
              />
            </div>
          </div>
          <el-button type="primary" style="margin-top: 100px;width: 80px;" :loading="uploading" @click="submit">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import XLSX from 'xlsx'
import * as qiniu from 'qiniu-js'
import { qiniuToken } from '@/api/qiniuToken'
import getNowDate from '@/utils/mixins/convertToHump.js'
import { quick_binds, addquick_binds, editquick_binds, delquick_binds, belong_list, listquick_release_groups, listrelease_group_user, import_bind } from '@/api/ListnewLaunchGroup.js'
import { getTitleList, dropLocationList } from '@/api/newLaunchGroup.js'
import { mapGetters } from 'vuex'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
import Details from './components/details.vue'
export default {
  components: {
    PaginationRight,
    ExpandClose,
    Details
  },
  mixins: [getNowDate],

  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        channel_code: null, // 渠道号
        release_group_id: null,
        pitcher_id: null,
        // alias_book_id: null,
        book_id: null
        // position_id: null
      },
      parameterNames: {
        channel_code: null, // 渠道号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null // 投放位置
      },
      current: null,
      dialogVisible: false,
      drawerItem: {},
      isL: false,
      dialogfiles: false,
      filesxlsx: '',
      filesxlsxname: '',
      hoverClass: 'el-icon-circle-check',
      token: '',
      uploading: false
    }
  },
  created() {
    window.aa = this
    this.getDataList()
    this.getQiniuToken()
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters(['getBindingRelationship'])
  },
  methods: {
    handleClick() {
      if (this.hoverClass === 'el-icon-circle-close') {
        this.filesxlsx = ''
        this.filesxlsxname = ''
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      }
    },
    async submit() {
      this.uploading = true
      console.log('this.query:', this.filesxlsx)
      await import_bind({
        excel_url: this.filesxlsx
      })
      this.uploading = false
      this.$message({
        message: '文件上传成功',
        type: 'success'
      })
      this.dialogfiles = false
    },
    getQiniuToken() {
      qiniuToken().then(res => {
        this.token = res.data.uptoken
      })
    },
    async uploadXlsx(e) {
      for (let i = 0; i < e.target.files.length; i++) {
        const fileIfon = e.target.files[i]
        // const temporary = e.target.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        // this.temporary = temporary
        // console.log('this.temporary :', e.target.files)

        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.xlsx'
        // eslint-disable-next-line eqeqeq
        if (!extension) {
          this.$message({
            message: '请上传正确的xlsx格式文件',
            type: 'error'
          })
          return
        }

        if (ftype === '.xlsx') {
          // console.log(22222222, this.getNowDate())
          const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
            fname: fileIfon.name // 文件名
          }, {
            useCdnDomain: true // CDN 域名加速
          })
          observable.subscribe({
            next() {},
            error(err) {
              console.log(err)
            },
            complete: (data) => {
              // console.log('data2:', ftype, data)
              this.filesxlsx = data.key
              this.filesxlsxname = e.target.files[0].name
            }
          })
        }
      }
    },
    // 获取数据列表
    async getDataList(obj = {}) {
      this.loading = true
      const data = await quick_binds(Object.keys(obj).length ? obj : this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.isL = true
      this.drawerItem = row
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 确定
    async determine(obj) {
      const bool = !!this.drawerItem.id

      if (bool) {
        await editquick_binds(this.drawerItem.id, obj)
      } else {
        await addquick_binds(obj)
      }

      this.$message({
        message: bool ? '修改关系成功' : '创建关系成功',
        type: 'success'
      })
      this.isL = true

      this.drawerItem = {}
      this.dialogVisible = false
      this.reset()
    },

    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        '投放组': 'release_group_name',
        '投手': 'user_name',
        '书籍归属': 'book_name',
        '书名': 'novel_name',
        '投放位置': 'position_name'
      }

      switch (this.current) {
        case '投放组': currentFunc = listquick_release_groups
          break
        case '投手': currentFunc = listrelease_group_user
          break
        case '书名': currentFunc = getTitleList
          break
        case '书籍归属': currentFunc = belong_list
          break
        case '投放位置': currentFunc = dropLocationList
          break
      }
      if (!currentFunc) {
        return
      }
      if (this.current === '投手' && !this.parameter.release_group_id || this.current === '书名' && !this.parameter.book_id) {
        const obj1 = {
          '投手': '请先选投放组，才能选投手',
          '书名': '请先选择书籍归属，才能选书名'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        group_id: this.current === '投手' ? this.parameter.release_group_id.address : null,
        book_belong_id: this.parameter.book_id ? this.parameter.book_id.address : null
      })
      cb(data.data.list.map((item) => {
        return {
          value: item[obj[this.current]],
          address: item.id
        }
      }))
    },

    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '投放组' : this.parameter.release_group_id = item
          break
        case '投手' : this.parameter.pitcher_id = item
          break
        // case '书名' : this.parameter.alias_book_id = item
          // break
        case '书籍归属' : this.parameter.book_id = item
          break
        // case '投放位置' : this.parameter.position_id = item
        //   break
      }
    },

    // 搜索
    search(value) {
      value || (this.parameter.page = 1)
      const obj = {
        channel_code: 'channel_code',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        // alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name'
        // position_id: 'position_id_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (this.parameter[key] && (this.parameter[key].value === this.parameterNames[obj[key]]) && key !== 'page' && key !== 'pageSize' && key !== 'channel_code') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'pageSize' && key !== 'channel_code') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      this.getDataList(obj1)
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10,
        channel_code: null,
        release_group_id: null,
        pitcher_id: null,
        alias_book_id: null,
        book_id: null,
        position_id: null
      }
      this.parameterNames = {
        channel_code: null, // 渠道号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null // 投放位置
      }
      this.current = null
      this.getDataList()
    },

    // 删除
    async myDelete(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await delquick_binds(row.id)
        this.getDataList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },

    // 创建按钮的点击事件的处理函数
    establish() {
      // console.log('有无数据回显===', this.isL, this.drawerItem)
      this.drawerItem = this.getBindingRelationship || {}
      this.dialogVisible = true
      this.isL = false
    },

    close() {
      // this.isL || this.$store.commit('bindingRelationship/setLastCreatedData', this.$refs.details.createTheDesiredStructure())
      this.$store.commit('bindingRelationship/setLastCreatedData', this.$refs.details.createTheDesiredStructure(this.isL))
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.el-icon-circle-check:before {
    content: "\e720";
    color: #67c23a;
    margin-left: 50px;
}
.el-icon-circle-close{
  margin-left: 50px;

}
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
       margin-right: 10px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}
</style>

<style>
.publicItems .el-dialog{
  margin-top: 6vh !important;
  min-width: 685px !important;
}
</style>
